'use client';
import { ValModulesClient as BaseValModulesClient } from '@valbuild/next';
import valModules from '../../val.modules';

export default function ValModulesClient() {
  return <BaseValModulesClient modules={valModules} />;
}
